export default __webpack_public_path__ + "static/media/glassware_light.71ecd7e1.png";